import React from 'react';

type TextAreaProps = {
    label?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    className?: string;
    name?: string;
    rows?: number;
};

const TextArea: React.FC<TextAreaProps> = ({
                                               label,
                                               value,
                                               onChange,
                                               placeholder = '',
                                               className = '',
                                               name,
                                               rows = 4,
                                           }) => {
    return (
        <div className={`flex flex-col mb-4 ${className}`}>
            {label && (
                <label className="mb-1 text-sm font-medium text-gray-700">
                    {label}
                </label>
            )}
            <textarea
                name={name}
                rows={rows}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        </div>
    );
};

export default TextArea;
